import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Card, CardContent, Switch } from '@mui/material';
import { Page, Header } from 'components';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import AddBoxIcon from '@mui/icons-material/AddBox';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import IncidentTrackerDatatable from './components/IncidentTrackerDatatable';
import IncidentTrackerDialog from './components/IncidentTrackerDialog/IncidentTrackerDialog';
import IncidentTrackerDeleteDialog from './components/IncidentTrackerDialog/IncidentTrackerDeleteDialog';
import IncidentTrackerAddFileDialog from './components/IncidentTrackerDialog/components/components/IncidentTrackerAddFileDialog';
import IncidentTrackerDeleteFileDialog from './components/IncidentTrackerDialog/components/components/IncidentTrackerDeleteFileDialog';
import IncidentTrackerOptionsDialog from './components/IncidentTrackerDialog/IncidentTrackerOptionsDialog';

import {
	SetFormState, GetIncidents, ToggleIncidentTrackerDialog,
	ToggleDeleteIncidentTrackerDialog, ExportIncidents,
	ToggleAttachFileIncidentTrackerDialog, ToggleRemoveFileIncidentTrackerDialog,
	ToggleOptionsIncidentTrackerDialog
} from '../actions/IncidentTrackerActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const IncidentTracker = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerDemoReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const incidents = useSelector((state) => state.incidentTrackerDemoReducer.incidents);
	const incidentTrackerDialogVisibility = useSelector((state) => state.incidentTrackerDemoReducer.IncidentTrackerDialogVisibility);
	const deleteIncidentTrackerDialogVisibility = useSelector((state) => state.incidentTrackerDemoReducer.deleteIncidentTrackerDialogVisibility);
	const attachFileIncidentTrackerDialogVisibility = useSelector((state) => state.incidentTrackerDemoReducer.attachFileIncidentTrackerDialogVisibility);
	const removeFileIncidentTrackerDialogVisibility = useSelector((state) => state.incidentTrackerDemoReducer.removeFileIncidentTrackerDialogVisibility);
	const optionsIncidentTrackerDialogVisibility = useSelector((state) => state.incidentTrackerDemoReducer.optionsIncidentTrackerDialogVisibility);

	useEffect(() => {
		if (incidentTrackerDialogVisibility === false && deleteIncidentTrackerDialogVisibility === false) {
			dispatch(GetIncidents(userId, role));
		}
	}, [incidentTrackerDialogVisibility, deleteIncidentTrackerDialogVisibility]);

	const _incidentTrackerDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleIncidentTrackerDialog(false));
		}
	};

	const _incidentTrackerDeleteDialogClose = () => {
		dispatch(ToggleDeleteIncidentTrackerDialog(false));
	};

	const _attachFileIncidentTrackerDialogClose = () => {
		dispatch(ToggleAttachFileIncidentTrackerDialog(false));
	};

	const _removeFileIncidentTrackerDialogClose = () => {
		dispatch(ToggleRemoveFileIncidentTrackerDialog(false));
	};

	const _optionsIncidentTrackerDialogClose = () => {
		dispatch(ToggleOptionsIncidentTrackerDialog(false));
	};

	const _onCreateSiteIncidentClick = () => {
		dispatch(ToggleIncidentTrackerDialog(true));
		setFormState({
			...formState,
			values: {
				...formState.values,
				cfnOwner: userId
			},
		});
	};

	const _onExportIncidentsClick = () => {
		dispatch(ExportIncidents(userId, role));
	};

	const _onOptionsClick = () => {
		dispatch(ToggleOptionsIncidentTrackerDialog(true));
	};

	const actions = [
		{ icon: <AddBoxIcon />, name: 'Create Ticket', id: 'createIncident' },
		{ icon: <FileOpenIcon />, name: 'Export Tracker', id: 'exportIncidents' },
	];

	/* 	if (role === 'Administrator' || role === 'Manager') {
		actions.push({ icon: <ManageAccountsIcon />, name: 'Options', id: 'options' });
	} */

	const _handleSpeedDialClick = (action) => {
		if (action.id === 'createIncident') {
			_onCreateSiteIncidentClick();
		} else if (action.id === 'exportIncidents') {
			_onExportIncidentsClick();
		} else if (action.id === 'options') {
			_onOptionsClick();
		}
	};

	const [formating, setFormating] = React.useState(true);
	function handleClick() {
		setFormating(true);
	}

	return (
		<Page className={classes.root} title="RF OPT Tracker">
			<Header module="Tracker" view="RF OPT" />
			<SpeedDial
				ariaLabel="SpeedDial"
				sx={{ position: 'absolute', bottom: 16, right: 16 }}
				icon={<SpeedDialIcon />}
			>
				{actions.map((action) => (
					<SpeedDialAction
						key={action.name}
						icon={action.icon}
						tooltipTitle={action.name}
						onClick={() => { _handleSpeedDialClick(action); }}
					/>
				))}
			</SpeedDial>
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<IncidentTrackerDatatable className={classes.results} data={incidents} />
					{incidentTrackerDialogVisibility && (
						<IncidentTrackerDialog
							onClose={_incidentTrackerDialogClose}
							open={incidentTrackerDialogVisibility}
						/>
					)}
					{deleteIncidentTrackerDialogVisibility && (
						<IncidentTrackerDeleteDialog
							onClose={_incidentTrackerDeleteDialogClose}
							open={deleteIncidentTrackerDialogVisibility}
						/>
					)}
					{attachFileIncidentTrackerDialogVisibility && (
						<IncidentTrackerAddFileDialog
							onClose={_attachFileIncidentTrackerDialogClose}
							open={attachFileIncidentTrackerDialogVisibility}
						/>
					)}
					{removeFileIncidentTrackerDialogVisibility && (
						<IncidentTrackerDeleteFileDialog
							onClose={_removeFileIncidentTrackerDialogClose}
							open={removeFileIncidentTrackerDialogVisibility}
						/>
					)}
					{optionsIncidentTrackerDialogVisibility && (
						<IncidentTrackerOptionsDialog
							onClose={_optionsIncidentTrackerDialogClose}
							open={optionsIncidentTrackerDialogVisibility}
						/>
					)}
				</Grid>
			</Grid>
		</Page>
	);
};

export default IncidentTracker;
